module.exports = __webpack_public_path__ + "assets/img/mr3.5a9c6da2.png";